function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getSideAxis(placement) {
  return ['above', 'below'].includes(placement) ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function clamp(start, value, end) {
  return Math.max(start, Math.min(value, end));
}
function getArrowPosition(trigger, floating, arrowBg, arrowFg, placement, alignment) {
  // this code is largely inspired by the floating-ui library:
  // https://github.com/floating-ui/floating-ui/blob/master/packages/core/src/middleware/arrow.ts
  // but has been adapted to work with the our arrow which has a foreground and background.
  // Our React library uses floating-ui, so we want to make sure the arrow positioning is consistent between the two.
  const rects = {
    trigger: trigger.getBoundingClientRect(),
    floating: floating.getBoundingClientRect(),
    arrowBg: arrowBg.getBoundingClientRect(),
    arrowFg: arrowFg.getBoundingClientRect()
  };
  const coords = {
    x: rects.floating.x,
    y: rects.floating.y
  };
  const axis = getAlignmentAxis(placement);
  const length = getAxisLength(axis);
  const isYAxis = axis === 'y';
  const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
  const endDiff = rects.trigger[length] + rects.trigger[axis] - coords[axis] - rects.floating[length];
  const startDiff = coords[axis] - rects.trigger[axis];
  const arrowOffsetParent = arrowBg.offsetParent;
  const clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
  const centerToReference = endDiff / 2 - startDiff / 2;
  // If the padding is large enough that it causes the arrow to no longer be
  // centered, modify the padding so that it is centered.
  const largestPossiblePadding = clientSize / 2 - rects.arrowBg[length] / 2 - 1;
  const minPadding = Math.min(0, largestPossiblePadding);
  const maxPadding = Math.min(0, largestPossiblePadding);
  // Make sure the arrow doesn't overflow the floating element if the center
  // point is outside the floating element's bounds.
  const min = minPadding;
  const max = clientSize - rects.arrowBg[length] - maxPadding;
  const center = clientSize / 2 - rects.arrowBg[length] / 2 + centerToReference;
  const offset = clamp(min, center, max);
  const shouldAddOffset = alignment !== undefined && center !== offset && rects.trigger[length] / 2 - (center < min ? minPadding : maxPadding) - rects.arrowBg[length] / 2 < 0;
  const alignmentOffset = shouldAddOffset ? center < min ? center - min : center - max : 0;
  // determine the difference in width between the arrow foreground and background
  const widthDifference = rects.arrowBg.width - rects.arrowFg.width;
  const borderOffset = widthDifference / 2;
  const insetProp = isYAxis ? 'top' : 'left';
  return {
    arrowBgStyle: {
      [insetProp]: offset + alignmentOffset + 'px'
    },
    arrowFgStyle: {
      [insetProp]: offset + alignmentOffset + borderOffset + 'px'
    }
  };
}
export { getArrowPosition };